module.exports = __webpack_public_path__ + "static/media/tooltip_icon.52fe7f26.svg";